module.exports = __webpack_public_path__ + "static/01_JPMC-487e313a80669c6f2a406ecc503dc805.png";